export const DownloadDemo = async (url: string, filename: string) => {
  const aElement = document.createElement('a');
  aElement.href = url;
  aElement.setAttribute('download', filename);
  aElement.click();
};
